/**
 * Automatic tns (tiny-slider) settings generation for all cmp-articles component. Setting is for all articles carousel the same, just the name of classes and object name differs between each tns instances.
 *
 * @version 1.1
 * @author Cenek Hybler <hybler@avast.com>
 * @requires cash
 */

(function() {
	'use strict';
	var
		$ = avm.require('cash'),

		//all carousel sliders
		$carousels = $('.carousel-slider .article-items'),

		// tiny slider configuration for given class name
		createSlider = function(className){
			window[className] = tns({
				"container": "."+className,
				"controlsContainer": "."+className+"-controls",
				"controlsPosition": "bottom",
				"preventScrollOnTouch": "force",
				"controls": false,
				"navPosition": "bottom",
				"nav": true,
				"mouseDrag": true,
				"speed": 400,
				"loop": false,
				"fixedWidth": 280,
				"slideBy": 1,
				"responsive": {
					"992": {
						"controls": true
					},
					"1280": {
						"fixedWidth": 316
					}
				},
				onInit: function(){
					$('.'+className+'-controls').attr('tabindex', -1);
					$('.'+className+'-controls [data-controls="next"]').attr('tabindex', 0);
					$('.carousel-slider .tns-nav').attr('tabindex', -1);
					$('.carousel-slider [data-nav]').attr('tabindex', 0);
				}
			});

			// bind function to event and make sure that prev button is no longer unaccessible¨
			// overrides the onInit function and disabled buttons settings
			window[className].events.on('indexChanged', function() {
				$('.'+className+'-controls [data-controls="prev"]:not([disabled])').attr('tabindex', 0);
			});
		};

	// detect all sliders and assign each a slider configuration by its class name. This expects that if there is more article carousels on the page, they have unique class (dafault class name is overriden by snippet parameter)
	$carousels.each(function() {
		var
			classesList = $(this).attr('class').split(/\s+/),
			secondClassName = classesList[1];

		createSlider(secondClassName);
	});
})();
